export default __webpack_public_path__ + "ui/assets/img/active-20.svg";